import { render, staticRenderFns } from "./InviteInstructors.vue?vue&type=template&id=736755f7&"
import script from "./InviteInstructors.vue?vue&type=script&lang=js&"
export * from "./InviteInstructors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports